/**
 * Accordion controller to toggle active state on wrappers and triggers.
 */
class AccordionHorizontal {
    constructor({
        wrapperAttr = 'wrapper',
        triggerAttr = 'trigger',
        activeClass = 'is-active',
        groupMode = false,
        groupAttr = 'group',
        preventSelfClose = false,
        onOpen = null,
        onClose = null
    } = {}) {
        this.wrapperAttr      = wrapperAttr;
        this.triggerAttr      = triggerAttr;
        this.activeClass      = activeClass;
        this.groupMode        = groupMode;
        this.groupAttr        = groupAttr;
        this.preventSelfClose = preventSelfClose;
        this.onOpen           = onOpen;
        this.onClose          = onClose;
    }

    init() {
        const wrappers = document.querySelectorAll(`[data-accordion="${this.wrapperAttr}"]`);

        if (!wrappers.length) {
            return;
        }

        wrappers.forEach((wrapper) => {
            const triggers = wrapper.querySelectorAll(`[data-accordion="${this.triggerAttr}"]`);

            if (!triggers.length) {
                return;
            }

            triggers.forEach((trigger) => {
                trigger.addEventListener('click', () => {
                    this.toggle(wrapper, triggers);
                    document.dispatchEvent(new CustomEvent('accordion:change'));
                });
            });
        });
    }

    toggle(wrapper, triggers) {
        const isActive       = wrapper.classList.contains(this.activeClass);
        const shouldActivate = !isActive;

        if (this.groupMode && this.preventSelfClose && isActive) {
            return;
        }

        if (this.groupMode) {
            const groupName = wrapper.getAttribute(`data-accordion-${this.groupAttr}`);

            if (groupName) {
                const groupWrappers = document.querySelectorAll(`[data-accordion="${this.wrapperAttr}"][data-accordion-${this.groupAttr}="${groupName}"]`);

                groupWrappers.forEach((groupWrapper) => {
                    if (groupWrapper !== wrapper) {
                        const wasActive = groupWrapper.classList.contains(this.activeClass);
                        groupWrapper.classList.remove(this.activeClass);
                        const groupTriggers = groupWrapper.querySelectorAll(`[data-accordion="${this.triggerAttr}"]`);
                        groupTriggers.forEach((trigger) => {
                            trigger.classList.remove(this.activeClass);
                        });

                        if (wasActive && this.onClose) {
                            this.onClose(groupWrapper, groupTriggers);
                        }
                    }
                });
            }
        }

        wrapper.classList.toggle(this.activeClass, shouldActivate);
        triggers.forEach((trigger) => {
            trigger.classList.toggle(this.activeClass, shouldActivate);
        });

        if (shouldActivate && this.onOpen) {
            this.onOpen(wrapper, triggers);
        } else if (!shouldActivate && this.onClose) {
            this.onClose(wrapper, triggers);
        }
    }
}

function calculateAccordionContentWidth() {
    if (window.innerWidth <= 1081) {
        return;
    }

    const grids = document.querySelectorAll('.made-according__grid');

    grids.forEach((grid) => {
        const columns      = parseInt(grid.style.getPropertyValue('--section-according-feature'), 10) || 1;
        const gridWidth    = grid.offsetWidth;
        const contentWidth = gridWidth - ((columns - 1) * 104);
        grid.style.setProperty('--accordion-content-width', `${contentWidth}px`);
    });
}

function debounce(func, wait) {
    let timeout;
    return (...args) => {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

export { AccordionHorizontal, calculateAccordionContentWidth, debounce };
